import yup from 'yup';
// translate
import messages from './messages';

export default yup.object({
  firstName: yup.string().required(messages.validationRequiredField),
  lastName: yup.string().required(messages.validationRequiredField),
  postcode: yup.string().required(messages.validationRequiredField),
  country: yup.string().required(messages.validationRequiredField),
  address: yup.string().required(messages.validationRequiredField),
  minSum: yup.string().required(messages.validationRequiredField),
  company: yup.string().required(messages.validationRequiredField),
});



// WEBPACK FOOTER //
// ./src/containers/Settings/formRules.js